import { useQuery } from 'react-query';
import { getBoolean, fetchAndActivate } from 'firebase/remote-config';

import { remoteConfig } from 'utils/firebase';

export interface IRemoteConfigValues {
  isPushToTalkEnabled: boolean;
  isAppUpdateNotificationEnabled: boolean;
  isConversationSpeedEnabled: boolean;
  isContinueWithGoogleEnabledIOS: boolean;
  isContinueWithGoogleEnabledAndroid: boolean;
  isContinueWithGoogleEnabledOther: boolean;
  isContinueWithAppleEnabledIOS: boolean;
}

export const getRemoteConfigValues = async () => {
  await fetchAndActivate(remoteConfig);

  const isPushToTalkEnabled = getBoolean(remoteConfig, 'isPushToTalkEnabled');
  const isAppUpdateNotificationEnabled = getBoolean(remoteConfig, 'isAppUpdateNotificationEnabled');
  const isConversationSpeedEnabled = getBoolean(remoteConfig, 'isConversationSpeedEnabled');
  const isContinueWithGoogleEnabledIOS = getBoolean(remoteConfig, 'isContinueWithGoogleEnabledIOS');
  const isContinueWithGoogleEnabledAndroid = getBoolean(remoteConfig, 'isContinueWithGoogleEnabledAndroid');
  const isContinueWithGoogleEnabledOther = getBoolean(remoteConfig, 'isContinueWithGoogleEnabledOther');
  const isContinueWithAppleEnabledIOS = getBoolean(remoteConfig, 'isContinueWithAppleEnabledIOS');

  return {
    isPushToTalkEnabled,
    isAppUpdateNotificationEnabled,
    isConversationSpeedEnabled,
    isContinueWithGoogleEnabledIOS,
    isContinueWithGoogleEnabledAndroid,
    isContinueWithGoogleEnabledOther,
    isContinueWithAppleEnabledIOS,
  };
};

export const useRemoteConfig = () =>
  useQuery({
    queryKey: ['useRemoteConfig'],
    queryFn: getRemoteConfigValues,
  });
